import playTypeMap from './playTypeMap';
const { PITCH, RESULT, RESULT_NO_IN_PLAY, PITCH_WITH_RESULT, NONE } = playTypeMap;

const getPlayType = (config) => {
    const { isComplete, pitch, justResult, resultAfterPitch } = config;
    if (justResult) {
        return RESULT_NO_IN_PLAY;
    } else if (resultAfterPitch) {
        return RESULT;
    } else if (pitch) {
        if (isComplete) {
            return PITCH_WITH_RESULT;
        }
        return PITCH;
    }

    return NONE;
};

const getPlayStartTimeHelper = (playType, validPitch, playEndTime) => {
    let pitchStartTime;
    let resultEndTime;
    if (playType === PITCH || playType === RESULT || playType === RESULT_NO_IN_PLAY || playType === PITCH_WITH_RESULT) {
        pitchStartTime = validPitch?.startTime;
        resultEndTime = playEndTime;
    } else if (playType === NONE) {
        pitchStartTime = undefined;
        resultEndTime = undefined;
    }

    return {
        pitchStartTime,
        resultEndTime
    };
};

export {
    getPlayStartTimeHelper,
    getPlayType
};
